import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../../../design/button";
import ColumnSelector from "../../../../../design/column-selector";
import Searchbar from "../../../../../design/search-bar";

interface SupervisorHeaderProps {
	openDialog: () => void;
	searchText: string;
	setSearch: (search: string) => void;
  columns: any;
  handleSelectColumns: any;
}

const SupervisorHeader: React.FC<SupervisorHeaderProps> = (
  {
    openDialog,
    searchText,
    setSearch,
    columns,
    handleSelectColumns,
  }) => {
  const { t } = useTranslation();

  return (
		<>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					flexDirection: "row",
					alignItems: "center",
					height: "60px",
					pl: 3,
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
          <ColumnSelector
            columns={columns}
            handleSelectColumns={handleSelectColumns}
          />
					<Searchbar
						variant={"filled"}
						width={"35ch"}
						setSearch={setSearch}
						value={searchText}
					/>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<Box ml={2} mr={5}>
						<Button iconBefore={<AddIcon />} onClick={openDialog}>
							{t("users_user")}
						</Button>
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default SupervisorHeader;
